export const API_EXTERNAL_ENDPOINT = 'cottages/list'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/list'
